var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "CommonMap",
    {
      attrs: {
        city: _vm.city,
        "fit-view-priority": _vm.fitViewPriority,
        avoid: [20, 20, 20, 20],
        "animate-enable": false,
        "rotate-enable": false,
        "map-style": _vm.mapStyle,
        "view-mode": "3D",
      },
    },
    [_vm._t("default")],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }